import { useEffect, useState } from 'react';
import { getAllActiveLeadStatus } from 'wisestep-api';

export const useActiveLeadStatus = () => {
  const [activeStatus, setActiveStatus] = useState<string[]>([]);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await getAllActiveLeadStatus();
        if (response?.data) {
          setActiveStatus(response.data);
        }
      } catch (error) {
        console.error('Failed to fetch active lead statuses:', error);
      }
    };

    fetchStatus();
  }, []);

  return activeStatus;
};
